<p-card
  class="p-col-12"
  styleClass="card-container"
  header="Freelance - furniture products"
>
  This is a <b>Web Application</b> used to display the furniture catalog .The
  technology used is <b>Angular.js CSS , HTML </b> .I had also experience in
  putting the web application in production
</p-card>

<p-card
  class="p-col-12"
  styleClass="card-container"
  header="Non-industry project"
>
  This is a <b>Web Application</b> used to digitize the existing business for
  broader market.My role is to provide service api's for the given scenario .The
  technology used is <b>Nest.js ,Mongoose ,Mongodb </b>
</p-card>
